import React from 'react';
import './styles.css';

const RatingStarsWidgetMinimal = ({ ratingValue, size }) => {
  return (
    <span className="rating-stars-widget-minimal">
      {` ${ratingValue} `}{' '}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.867 55.867"
        width={size}
        height={size}
      >
        <path
          d="M55.818 21.578c-.118-.362-.431-.626-.808-.681l-18.09-2.629-8.09-16.392c-.168-.342-.516-.558-.896-.558s-.729.216-.896.558l-8.091 16.393-18.09 2.629c-.377.055-.689.318-.808.681-.117.361-.02.759.253 1.024l13.091 12.76-3.091 18.018c-.064.375.09.754.397.978.309.226.718.255 1.053.076l16.182-8.506 16.18 8.506c.146.077.307.115.466.115.207 0 .413-.064.588-.191.308-.224.462-.603.397-.978l-3.09-18.017 13.091-12.761c.272-.267.37-.664.252-1.025z"
          fill="inherit"
        />
      </svg>
    </span>
  );
};

export default RatingStarsWidgetMinimal;
